import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllPrintifyProducts } from "../../utils/printify/printify.utils";

export const getAll = createAsyncThunk("products/getAll", async () => {
  const data = await getAllPrintifyProducts();
  return data;
});
